import React from "react";

const ReturnPolicy = () => {
  return (
    <div className="bg-[#f5f7fb] min-h-screen py-10 px-4">

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-6 md:p-10">

        {/* HEADER */}
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Cancellation & Return Policy
        </h1>

        <p className="text-sm text-gray-500 mb-6">
          Last Updated: 2025
        </p>

        {/* INTRO */}
        <p className="text-gray-700 mb-6 leading-relaxed">
          At <b>LappyShop</b>, we specialize in high-quality refurbished laptops.
          Your satisfaction is our priority. If you're not happy with your purchase,
          please review our cancellation, return, and warranty policies below.
        </p>

        {/* SECTION */}
        <Section title="1. Cancellation Policy">
          <ul className="list-disc pl-5 space-y-1">
            <li>You can cancel your order before it is shipped.</li>
            <li>Payment gateway charges (minimum ₹500) may be deducted.</li>
            <li>If cancelled after dispatch, shipping + processing fees will be deducted.</li>
          </ul>
        </Section>

        <Section title="2. 14-Day Return Policy (Refurbished Devices)">
          <p className="mb-2">
            You can return or replace your laptop within <b>14 days</b> if:
          </p>

          <ul className="list-disc pl-5 space-y-1">
            <li>Product is defective or not as described</li>
            <li>Missing accessories or components</li>
            <li>Fails our quality standards</li>
          </ul>
        </Section>

        <Section title="3. Warranty (Refurbished Laptops)">
          <ul className="list-disc pl-5 space-y-1">
            <li>Up to 1 year warranty on manufacturing defects</li>
            <li>6 months warranty on battery & adapter</li>
            <li>Physical or liquid damage not covered</li>
          </ul>
        </Section>

        <Section title="4. Buyback Program">
          <p>
            You can return your laptop anytime during warranty with depreciation
            (minimum 5% per month or 12% whichever is higher).
          </p>
        </Section>

        <Section title="5. Return Conditions">
          <ul className="list-disc pl-5 space-y-1">
            <li>Product must be in original condition</li>
            <li>All accessories & packaging included</li>
            <li>No personal data should remain on device</li>
            <li>Proper packaging required during return</li>
          </ul>
        </Section>

        <Section title="6. Non-Returnable Cases">
          <ul className="list-disc pl-5 space-y-1">
            <li>Physical damage caused by customer</li>
            <li>Customized products</li>
            <li>Improper handling or misuse</li>
          </ul>
        </Section>

        <Section title="7. Refund Process">
          <ul className="list-disc pl-5 space-y-1">
            <li>Refund initiated within 24–48 hrs after inspection</li>
            <li>Credited within 7–14 business days</li>
            <li>Refund goes to original payment method</li>
          </ul>
        </Section>

        <Section title="8. Quality Check">
          <p>
            Every refurbished laptop is tested under strict quality checks before approval.
          </p>
        </Section>

        <Section title="9. Policy Updates">
          <p>
            LappyShop reserves the right to update this policy anytime.
            Please review periodically.
          </p>
        </Section>

        <Section title="10. Contact Us">
          <p>
            📧 Email: support@lappyshop.com <br />
            📞 Phone: +91-9871238339 <br />
            🌐 Website: www.lappyshop.com
          </p>
        </Section>

      </div>

    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-6">
    <h2 className="text-lg md:text-xl font-semibold mb-2">
      {title}
    </h2>
    <div className="text-gray-700 text-sm leading-relaxed">
      {children}
    </div>
  </div>
);

export default ReturnPolicy;